module.exports = __webpack_public_path__ + "static/projectsettings-201840870f7ed74af05355d9f39d75cb.png";